import { HrCommonAuthority } from './hr-common-authority';
import { combineAuth } from './hr-authority';

export class TimeManagementAuthority extends HrCommonAuthority {

    public static readonly TIME_MANAGEMENT_BASE = "time-management";

    constructor(authority: string) {
        super(combineAuth(TimeManagementAuthority.TIME_MANAGEMENT_BASE, authority));
    }

}
